import Ajax from '@utils/ajax';

export function submitSurvey(surveyId, data) {
	data = Ajax.prepareData(data, Ajax.prepareDataTypes.FORM_DATA);

	return Ajax.post(`/enps/survey/${ surveyId }`, data);
}
